<template>
  <div class="breadcrumb">
    <div class="container-fluid">
      <ul>
        <li v-for="(item, index) in items" :key="index">
          <router-link v-if="index < items.length - 1" :to="item.path">{{ item.name }}</router-link>
          <span v-else class="breadcrumb-current">{{ item.name }}</span>
          <i v-if="index < items.length - 1" class="pi pi-angle-left breadcrumb-sep"></i>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true
    },
  },
}
</script>

<style scoped>
.breadcrumb ul {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  list-style: none;
  padding: 0;
  margin: 0;
  gap: 0;
}

.breadcrumb ul li {
  display: inline-flex;
  align-items: center;
}
</style>
